module.exports = {
  CHAIN_ID: 56,
  // RPC_URL: 'https://bsc-dataseed1.binance.org/' ,
  RPC_URL: "https://bsc-dataseed1.binance.org",

  // EX_LINK: "https://bscscan.com/address/", // Live 2
  EX_LINK: "https://bscscan.com/address/", // Live 2

  DEX_LINK:
    "https://pancakeswap.finance/swap?chain=bsc&inputCurrency=0xcF4a682545FaBE24551101820022fF66A016207d&outputCurrency=0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c", // Live 2

  // Constant
  ZERO_ADDRESS: "0x0000000000000000000000000000000000000000",

  PTN_TOKEN_ADDRESS: "0xD9E90DF21F4229249E8841580cDE7048bF935710",
  WETH_TOKEN_ADDRESS: "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c",
  UNISWAP_ROUTER_ADDRESS: "0x10ED43C718714eb63d5aA57B78B54704E256024E",
  // UNISWAP_ROUTER_ADDRESS:"0x3fC91A3afd70395Cd496C647d5a6CC9D4B2b7FAD",
  WETHX_TOKEN_ADDRESS: "0xcF4a682545FaBE24551101820022fF66A016207d",
  POTION_DAO_CHEF_ADDRESS: "0xd8d4bf1bcB9Db777188A20Ee458e9F560092644c",
  PTN_RESERVE: "0x11fD476A7e14e50b514A452B9B2d847366D647bE",
  POTION_DAO_STAKING_ADDRESS: "0x36D7fa1C701aAA811F8736C40435C50Bb77BF843", // home
  POTION_DAO_TREASURY_ADDRESS: "0x9B9AC5F5508e723687b483f53EceA768d9ad9A61",
  PTNTREASURY_FUND_ADDRESS: "",
  POTION_DAO_ZAP_ADDRESS: "0x27D22b46294e4204aF76494cbC9a221AB072e68c",
  // WETHX_PTN_POOL_ADDRESS: "0x510fb3A9bdFA2D0AcD9Af8a106D87418b59b6DAA",
  WETHX_PTN_POOL_ADDRESS: "0xcc40896e6d0C8Dd93Bd9DFaF11118B338015EcD4",
 
  WETH_PTN_ORACLE_ADDRESS: "",
  WETHX_WETH_ORACLE_ADDRESS: "0x02381533D1ae845EC85B7303aA78B95a102Da0ff",
  WETHX_PTN_MASTER_ORACLE_ADDRESS: "0x6Cb783e22f4DeDc9f4116c16ed2C8cfaF532D08e",

  POINT_SYSTEM: "0x87786B2B510B2EbB4d81931419669dAb35e84558",

  SHLD_BNB_LP: "0xA976a4ba5076f1264e0f8fFB5b9ff4aC9Fd615fa", // farm
  BNBX_BNB_LP: "0xb5A343D746be5942B37e222678979F124ecE8f68",
  GUARD_GUARDX_LP: "0x6041b5a399e0535cC754276E979541398595282F",

  BNB_ORACLE: "0x0567F2323251f0Aab15c8dFb1967E4e8A7D42aeE",

  BNB_GUARD_ORACLE: "0xA202608b6FB35346b586aAEe5A00967b1eeCb435",

  TOKEN_CLAIM: "0x1880068A4a04F9644A52fbB5e86f50A2f4006901",

  GUARDX_POOL_ADDRESS: "0xDD2Ad360C43f10482B4DdBE55fD9bEd0C46f7e90",
  GUARD_TOKEN_ADDRESS: "0xF606bd19b1E61574ED625d9ea96C841D4E247A32",
  GUARDX_MASTER_ORACLE_ADDRESS: "0xBc10d84c3fc7A7e8a6817911E1ce1C7713Faf93f",

  GUARD:"0xF606bd19b1E61574ED625d9ea96C841D4E247A32",
  GUARDX:"0xFAFeA5aC4D58c39540c188e7DEc59C4a9fA8b8Cf",

  BNBX_GUARDX_LP: "0x47980273e8B852BEE6dF646aC2897b349dD6f2A8",

  NEW_ZAP_ADDRESS: "0x22f974F5dbAD00E400C1609F39810A00F3ef958E",

  UNISWAP_FACTORY_ADDRESS: "0xcA143Ce32Fe78f1f7019d7d551a6402fC5350c73",


  ANDY_TOKEN_ADDRESS: "0x01CA78a2B5F1a9152D8A3A625bd7dF5765eeE1D8",
  ANDYX: "0xBfe801aa35fBA4719E9379A4b4850afA5c09E668",
  ANDY_ANDYX_LP: "0x00A67F0cab60B52E1a1c93aA887D6E22E7A3C31C",
  BNBX_ANDYX_LP: "0x49eb19a92FAce38A4d93DD0A70Ac481128BC26Bb",
  ANDY_BNB_ORACLE: "0x79e69cf6E5C154b9b12BbA2ce1E9A5bDE564509E",
  ANDY_SHIELD_ORACLE: "0x46A336A42741eB7E8282d27740C3063c453A9bC1",
  ANDY_ANDYX_ORACLE: "0x3E0Aa4b19eB7b83424ff32287a025734BCfb0115",
  ANDYX_MASTER_ORACLE_ADDRESS: "0x034D1FEFC4727C3fFB2B6d16c856Df04C6c56F04",
  ANDYX_POOL_ADDRESS: "0x552dA260cDe6aC1f96cd07874Ae276A7195fa619",

  ANDY: "0x01CA78a2B5F1a9152D8A3A625bd7dF5765eeE1D8",
  V3_QUOTER_ADDRESS: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",

  ANDY_ZAPPER: "0x5E0C30D125BBb4316F69f5e2a3a669Be53988f42"
  

  // Testnet

  // PTN_TOKEN_ADDRESS : "0xdC8f02695cc0224B0178403Fee45318beCFc8F71",
  // WETH_TOKEN_ADDRESS: "0xd151057229C8893Bb3Ca89Aa2DFD0794ad059fff",
  // WETHX_TOKEN_ADDRESS: "0x450674088284A54D09F32e8dA238fAe3F22a19A4",

  // POTION_DAO_CHEF_ADDRESS:"0xb14c4379bFAa1f5863bC8c8440484ddc1e8bd9a1",
  // POTION_DAO_STAKING_ADDRESS: "0x8E21A4CD617afd1a3267AC210Ae700F4e16778e6",
  // POTION_DAO_TREASURY_ADDRESS: "0xBa83b88195D970B532CE5eD553bdBc1Dd78096eb",
  // POTION_DAO_ZAP_ADDRESS: "0xD4978946f563491bcB6aD06aAb1b8898780d8993",

  // WETHX_PTN_POOL_ADDRESS: "0x90CC3Da7bb7b8a9F8ce00dd132585e4020755339",
  // WETHX_PTN_MASTER_ORACLE_ADDRESS: "0xcD0ad8653e9b1329288A08d21C59372Ed0a28Af6",
  // WETHX_WETH_ORACLE_ADDRESS: "0x1F731E63293622BcC3ef4fe27580A1B78057f960",
  // WETH_PTN_ORACLE_ADDRESS: "0xc28F447f278C9CeD917365AD1dB91C769Bce9C7A",

  // // MNTDAOFUND_ADDRESS: "0x3F13E18C3ecc2fB44664f44203E6C28e662A4Cdf",
  // // MNTDEVFUND_ADDRESS: "0xf22756b5bfAC53e40a23a15BdFF7e996D842D7bF",
  // PTNTREASURY_FUND_ADDRESS: "0xa8b6d16c3Df83Fb6a6157082F3EE9f4ed3c66420",

  // UNISWAP_ROUTER_ADDRESS:"0x10ED43C718714eb63d5aA57B78B54704E256024E"
  // MNTDAOFUND_ADDRESS: "0x3F13E18C3ecc2fB44664f44203E6C28e662A4Cdf",
  // MNTDEVFUND_ADDRESS: "0xf22756b5bfAC53e40a23a15BdFF7e996D842D7bF",
};
